import { LOCALSTORAGE_KEY } from "./constants"
import { getItem } from "./localstorage"

export const isLoggedIn = () => {
	return getItem(LOCALSTORAGE_KEY) != null
}

export const handleChangeNumeric = (val, setFn) => {
	const re = /^[0-9\b]+$/;

	if (val === '') {
		setFn(0)
	} 
	
	if (re.test(val)) {
		setFn(parseInt(val))
	}
}

export const convertBytesToKB = (bytes) => Math.round(bytes / 1000)

export const isFunction = (fn) => {return typeof fn === 'function'}

export const capitalizeWord = (word) => word.charAt(0).toUpperCase() + word.slice(1)

export const roundToTwo = (num) => {
	return + (Math.round(num + "e+3") + "e-2") * 10;
}

export const getFileData = (fileUrl) => {
	const data = {
		nombre: '',
		extension: '',
		icono: 'fa fa-file'
	}

	if (fileUrl) {
		const filePartes = fileUrl.split('/')
		const nombreArchivo = filePartes[filePartes.length - 1]
		const extensionPartes = nombreArchivo.split('.')
		const extension = extensionPartes[extensionPartes.length - 1]

		switch (extension) {
			case 'pdf':
				data.icono = 'fa fa-file-pdf'
				break
			case 'docx':
			case 'doc':
				data.icono = 'fa fa-file-word'
				break
			case 'pptx':
			case 'ppt':
				data.icono = 'fa fa-file-powerpoint'
				break
		}

		data.nombre = nombreArchivo
		data.extension = extension
	}

	return data
}